export default __webpack_public_path__ + "static/media/cube.b7340fd4.png";